<template>
    <div>
        <div class="row">
            <div class="col" style="max-width:400px; margin:auto; margin-top:50px;">
                <div class="roundbox">
                    <div class="rbcontent">
                        <div class="profile-and-edit">
                            <div class="user-profile-picture" :title="translate('changeProfilePic')" @click="toggleShow">
                                <img :src="getProfilePicture" />
                                <div class="change">
                                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-camera-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                                        <path fill-rule="evenodd" d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="editProfile">
                                <!-- <router-link :to="{ name: 'UserIdentity', params: { id: user.Id } }" class="btn btn-primary">{{translate('userProfile.editInfo')}}</router-link> -->
                                <router-link :to="{ name: 'UserIdentity', params: { id: user.Id } }" class="btn btn-outline-primary">
                                    <svg class="bi bi-pencil-square" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                                    </svg>
                                </router-link>
                            </div>
                        </div>
                        <h3 class="text-center" style="margin: 30px 0 0 0;">{{user.FullName}}</h3>
                        <div class="text-center" v-if="user.Title">{{user.Title}}</div>
                        
                        

                        <hr/>

                        <div>
                            <span class="text-muted">{{translate('login.email')}} :</span>
                            {{user.Email}}
                        </div>
                        <div>
                            <span class="text-muted">{{translate('userIdentity.mobilePhone')}} :</span>
                            {{user.Mobile}}
                        </div>
                        <div v-if="user.MobileSignOperator">
                            <span class="text-muted">{{translate('login.mobileSignature')}} : </span>
                            {{user.MobileSignOperator | serviceProviders}} {{user.MobileSignNumber}}
                        </div>

                        <div style="height:20px;"></div>
                            
                    </div>
                    <img-upload field="img"
                        @crop-success="cropSuccess"
                        @crop-upload-success="cropUploadSuccess"
                        @crop-upload-fail="cropUploadFail"
                        lang-type="tr"
                        :lang-ext="langExt"
                        v-model="show"
                        :width="300"
                        :height="300"
                        :url="uploadUrl"
                        :headers="headers"
                        img-format="png"></img-upload>
                </div>
            </div>
            <div class="col" style="margin-top:50px;">
                <div class="roundbox">
                    <div class="rbcontent head">
                        <h2>{{translate('approvalAuthorityEditor.departments')}}</h2>
                    </div>
                    <div class="pl-4 pb-4 pt-2">
                        <span v-for="(dept) in user.DepartmentNames" :key="dept">
                            <svg class="bi bi-check text-success" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"></path>
                            </svg>
                            {{dept}}
                            <br>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col" style="margin-top:50px;">
                    <div class="roundbox">
                        <div class="rbcontent head">
                            <h2>{{translate('userIdentity.auths')}}</h2>
                        </div>
                        <div class="pl-4 pb-4 pt-2">
                            <span v-for="(auth) in user.AuthorityNames" :key="auth">
                                <svg class="bi bi-check text-success" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"></path>
                                </svg>
                                {{auth}}
                                <br>
                            </span>
                        </div>
                    </div>
                </div>
        </div>
        <div class="row">
            <div class="col" style="margin-top:50px;">
                <div class="roundbox">
                    <div class="rbcontent head">
                        <h2>{{translate('userProfile.authorizedKEPAccounts')}}</h2>
                    </div>
                    <div>
                        <rem-password-list></rem-password-list>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="roundbox" style="margin-top:30px;">
                    <div class="rbcontent head">
                        <h2>{{translate('userProfile.loginHistory')}}</h2>
                    </div>
                    <table v-if="pastSessions" class="table table-sm  table-striped table-condensed" style="font-size:0.7rem;">
                        <thead>
                            <tr>
                                <th style="width:1px;"></th>
                                <th>{{translate('userProfile.device')}}</th>
                                <th>{{translate('userProfile.operatingSystem')}}</th>
                                <th>{{translate('userProfile.browser')}}</th>
                                <th>{{translate('userProfile.ipAddress')}}</th>
                                <th>{{translate('userProfile.source')}}</th>
                                <th>{{translate('userProfile.validationType')}}</th>
                                <th>{{translate('userProfile.date')}}</th>
                                <th>{{translate('userProfile.time')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="s in pastSessions" :key="s.Key">
                                <td><icon-circle-fill viewBox="0 0 16 16" width="10" height="10" :class="{ 'text-success' : s.IsValid, 'text-danger': !s.IsValid }"/></td>
                                <td>{{s.Device}}</td>
                                <td>{{s.OS}}</td>
                                <td>{{s.UA}}</td>
                                <td>{{s.IP}}</td>
                                <td>{{s.Source}}</td>
                                <td>{{s.Kind}}</td>
                                <td>{{s.CreateDate | datetime}}</td>
                                <td>{{parseInt((Date.parse(s.IsValid ? new Date() : s.LastValidDate || new Date()) - Date.parse(s.CreateDate)) / 60000)}} dk.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import imgUpload from 'vue-image-crop-upload';
import iconCircleFill from '../components/Icons/circle-fill.svg';
import remPasswordList from '../components/RemPasswordList.vue'

export default {
    components: {
        imgUpload,
        iconCircleFill,
        remPasswordList
    },
    created(){
        axios.get('/pastsessions/get')
        .then(x => {
            this.pastSessions = x.data;
        })
        .catch(() => {
            this.pastSessions = [];
        })
    },
    data(){
        return {
            pastSessions: null,
            show: false,
			headers: {
				token: axios.defaults.headers.common['token']
			},
            imgDataUrl: '', // the datebase64 url of created image
            langExt: {
                hint: this.translate('user.helperText'),
                loading: this.translate('loading'),
                noSupported: this.translate('user.browserNotSupported'),
                success: this.translate('messages.uploadSuccess'),
                fail: this.translate('errors.uploadFailed'),
                preview: this.translate('preview'),
                btn: {
                    off: this.translate('cancel'),
                    close: this.translate('close'),
                    back: this.translate('anotherFile'),
                    save: this.translate('okay')
                },
                error: {
                    onlyImg: this.translate('onlyPic'),
                    outOfSize: this.translate('fileSizeExceeded'),
                    lowestPx: this.translate('picSizeSmall')
                }
            }
        }
    },
    methods: {
        toggleShow() {
            this.show = !this.show;
        },
        /**
         * crop success
         *
         * [param] imgDataUrl
         * [param] field
         */
        cropSuccess(imgDataUrl, field){
            console.log('-------- crop success --------', field);
            this.imgDataUrl = imgDataUrl;
        },
        /**
         * upload success
         *
         * [param] jsonData  server api return data, already json encode
         * [param] field
         */
        cropUploadSuccess(jsonData, field){
            console.log('-------- upload success --------');
            console.log(jsonData);
            this.$root.$data.login.User.ProfilePictureUrl = jsonData.ProfilePictureUrl;
            window.location.reload();
            console.log('field: ' + field);
        },
        /**
         * upload fail
         *
         * [param] status    server api return error status, like 500
         * [param] field
         */
        cropUploadFail(status, field){
            console.log('-------- upload fail --------');
            console.log(status);
            console.log('field: ' + field);
        }
    },
    computed: {
        user(){
            return this.$root.$data.login.User;
        },
        uploadUrl(){
            return window.settings.apiUrl + '/user/setprofilepicture/' + this.user.Id;
        }
    }
}
</script>
<style  scoped>
.user-profile-picture {
    cursor: pointer;
    margin:auto;
    margin-bottom: 20px;
    width:100px;
    height:100px;
    border-radius:50px;
    overflow:hidden;
    box-shadow: 0px 0px 0px 8px rgba(0, 0, 0, 0.06);
}

.user-profile-picture img {
    width:100px;
    height:100px;
}

.user-profile-picture .change {
    text-align: center;
    width:100px;
    height:40px;
    background: rgba(0, 0, 0, 0.3);
    position: relative;
    margin-top: -40px;
    color:#EEE;
    transition: opacity .5s;
    opacity: 0;
}

.user-profile-picture:hover .change {
    opacity: 1;
}

#dvPopOver{
    margin-top: 5px;
}

[data-popover='departments'] {
  line-height: 1.5;
  margin: 5px;
  ;
}

[data-popover='authorities'] {
  line-height: 1.5;
  margin: 5px;
}

.editProfile{
    position: absolute;
    right: 25px;
    top: 10px;
}
</style>